import React, { Dispatch, SetStateAction } from 'react';
import VoxelDialog from '../../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogContent from '../../../../../components/voxel/Dialogs/VoxelDialogContent';
import {
  TagPlanAnalysisGqProps,
  UploadAnalysisGq,
} from '../../../../../graphql/projects/queries/contentPlan/useGetContentPlanGq';
import { ContentPlanStatus, ContentPlanType } from '../../../ContentPlanPage';
import ContentProcessingItem from './ContentProcessingItem';

export interface ContentPlanProcessingDialogProps {
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
  uploadAnalysis?: UploadAnalysisGq;
  tagPlanAnalysis?: TagPlanAnalysisGqProps;
  status: ContentPlanStatus;
  type: ContentPlanType;
}

export const ContentPlanProcessingDialog: React.FC<ContentPlanProcessingDialogProps> = ({
  openDialog,
  setOpenDialog,
  uploadAnalysis,
  tagPlanAnalysis,
  status,
  type,
}) => {
  const ingestedComplete =
    (uploadAnalysis?.ingestedBatchesCount > 0 ||
      !!uploadAnalysis?.contentUpload?.csvParsingEndTime) &&
    uploadAnalysis?.ingestedBatchesCount == uploadAnalysis?.contentUpload?.csvBatches;

  return (
    <VoxelDialog open={openDialog} onClose={() => setOpenDialog(false)}>
      <VoxelDialogContent className='pt-8'>
        {/* Crawl status */}
        {type === 'crawl' && (
          <>
            {!!uploadAnalysis.contentUpload.rerunStartTime && (
              <ContentProcessingItem
                title={'Adding keywords to existing URLs'}
                started={true}
                complete={!!uploadAnalysis.contentUpload.addToExistingEndTime}
                failed={!!uploadAnalysis.contentUpload.addToExistingFailTime}
              />
            )}
            <ContentProcessingItem
              title={'Inserting URLs'}
              started={!!uploadAnalysis.contentUpload.csvParsingStartTime}
              complete={ingestedComplete}
              failed={!!uploadAnalysis.contentUpload.csvParsingFailTime}
              divider={true}
            />
            <ContentProcessingItem
              title={'Creating recommendations'}
              started={ingestedComplete}
              complete={!!uploadAnalysis.contentUpload.duplicateCheckEndTime}
              divider={true}
            />
            <ContentProcessingItem
              title={'Adding create keywords'}
              started={ingestedComplete}
              complete={!!uploadAnalysis.contentUpload.addCreateKeywordsEndTime}
            />
          </>
        )}

        {/* Tag progress */}
        {type === 'tag' && (
          <>
            <ContentProcessingItem
              title={'Inserting tag combinations'}
              started={true}
              complete={
                tagPlanAnalysis.ingestCombinationsCount ===
                tagPlanAnalysis.totalCombinationsCount
              }
              divider={true}
            />
            <ContentProcessingItem
              title={'Merging URLs if needed'}
              started={
                tagPlanAnalysis.ingestCombinationsCount ===
                tagPlanAnalysis.totalCombinationsCount
              }
              complete={!!tagPlanAnalysis.contentTagPlan.mergeEndTime}
              divider={true}
            />
            <ContentProcessingItem
              title={'Removing duplicates'}
              started={
                tagPlanAnalysis.ingestCombinationsCount ===
                tagPlanAnalysis.totalCombinationsCount
              }
              complete={!!tagPlanAnalysis.contentTagPlan.duplicateCheckEndTime}
            />
          </>
        )}
      </VoxelDialogContent>
    </VoxelDialog>
  );
};

export default ContentPlanProcessingDialog;
